import { getImageBuilder } from '@/app/lib/media-helper';
import { SettingsQueryResult } from '@/sanity.types';
import { dataset, projectId, studioUrl } from '@/sanity/lib/api';
import { createDataAttribute, CreateDataAttributeProps } from 'next-sanity';

export function resolveOpenGraphImage(image: NonNullable<SettingsQueryResult>['ogImage'], width = 1200, height = 627) {
  if (!image) return;
  const url = getImageBuilder(image).width(1200).height(627).fit('crop').url();
  if (!url) return;
  return { url, alt: (image as any)?.alt as string, width, height };
}

// Depending on the type of link, we need to fetch the corresponding page, post, or URL.  Otherwise return null.
export function linkResolver(link: any) {
  if (!link) return null;

  // Support both shapes: portable-text markDefs ({linkType, href, page, post}) and our Link type ({type, url, anchor})
  const linkType: string | undefined = link.linkType ?? link.type;

  switch (linkType) {
    case 'href':
      return link.href ?? link.url ?? null;
    case 'page':
      return typeof link.page === 'string' ? `/${link.page}` : (link.url ?? null);
    case 'internal':
      return link.url ?? null;
    case 'external':
      return link.url ?? null;
    case 'anchor':
      return link.anchor ? `#${link.anchor}` : null;
    default:
      // Fallbacks when no explicit type provided
      if (link.href) return link.href;
      if (link.url) return link.url;
      // Handle direct URL strings
      if (typeof link === 'string') return link;
      return null;
  }
}

type DataAttributeConfig = CreateDataAttributeProps & Required<Pick<CreateDataAttributeProps, 'id' | 'type' | 'path'>>;

export function dataAttr(config: DataAttributeConfig) {
  return createDataAttribute({
    projectId,
    dataset,
    baseUrl: studioUrl,
  }).combine(config);
}
